import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { getSession } from '../lib/session'

/**
 * AuthGate — a THIN route guard (no forms, no Landing).
 *
 * Logged in  → render the gated children (the console).
 * Logged out → redirect to the dedicated /signin page, preserving the exact
 *              destination in `?next=` so the user lands back where they were
 *              after authenticating.
 *
 * All the sign-in / sign-up / forgot / reset UI + Supabase logic now lives on
 * the dedicated auth pages (see src/pages/SignIn.jsx … and src/lib/useAuth.js).
 */
export default function AuthGate({ children }) {
  const { pathname, search } = useLocation()

  if (getSession()?.apiKey) return children

  return <Navigate to={`/signin?next=${encodeURIComponent(pathname + search)}`} replace />
}
